module.exports = __webpack_public_path__ + "img/ajans-press-courier-ad-06.3511b779.jpg";